import React from 'react'

function TplCategoryIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="160" height="80" viewBox="0 0 160 80" {...props}>
      <defs>
        <clipPath id="TplCategoryIcon">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H160V80H0z"
            data-name="Rectangle 9611"
            transform="translate(13551 -2510)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-2">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H112V83H0z"
            data-name="Rectangle 9610"
            transform="translate(24.531 -.198)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-3">
          <path
            fill="#757575"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M21.07 1.888l.106 23.683a1.994 1.994 0 01-2 2.018L0 27.5 5.554 8.129a11.161 11.161 0 013.189-5.165h0A11 11 0 0115.928.073L19.162 0A1.864 1.864 0 0120.5.542a1.907 1.907 0 01.57 1.346z"
            data-name="Path 76574"
          ></path>
        </clipPath>
        <clipPath id="clip-path-4">
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M11.67 0a11.921 11.921 0 0111.776 11.91 11.66 11.66 0 01-11.669 11.8A11.921 11.921 0 010 11.8 11.66 11.66 0 0111.67 0z"
            data-name="Path 76581"
          ></path>
        </clipPath>
        <clipPath id="clip-path-5">
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M26.222 10.402a11.728 11.728 0 00-15.915-4.836 11.854 11.854 0 00-4.64 16.053 11.728 11.728 0 0015.918 4.84 11.854 11.854 0 004.637-16.057z"
            data-name="Path 76587"
          ></path>
        </clipPath>
        <clipPath id="clip-path-6">
          <path
            fill="#757575"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M21.141 25.721l.031-23.7a2.01 2.01 0 00-2-2.025L0 .026l5.613 19.4a11.264 11.264 0 003.2 5.178h0a11.055 11.055 0 007.191 2.917l3.233.083a1.85 1.85 0 001.341-.537 1.9 1.9 0 00.563-1.346z"
            data-name="Path 76603"
          ></path>
        </clipPath>
        <clipPath id="clip-path-7">
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M11.7 23.391a11.827 11.827 0 0011.733-11.877A11.472 11.472 0 0011.731 0 11.545 11.545 0 000 11.545a11.752 11.752 0 0011.7 11.846z"
            data-name="Path 76610"
          ></path>
        </clipPath>
        <clipPath id="clip-path-8">
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M26.251 21.644a11.665 11.665 0 01-15.894 4.79 11.917 11.917 0 01-4.69-16.078 11.665 11.665 0 0115.894-4.79 11.917 11.917 0 014.69 16.078z"
            data-name="Path 76616"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 650" transform="translate(-13551 2510)">
        <g clipPath="url(#clip-path-2)" data-name="Mask Group 649" transform="translate(13550.469 -2511.802)">
          <g transform="translate(-25.906 .481)">
            <g data-name="Group 57763">
              <g transform="rotate(7 4.243 69.372)">
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M27.645.567L41.253 0l14.9.918 5.4 1.527c1.579.006 6.965 4.307 7.352 5.263l9.365 17.63a4.48 4.48 0 003.213 2.711 11.681 11.681 0 005.682-.7s3.88.62 4.2.7c1.365.327 3.331 3.3 4.695 4.4.463 2.018 3.732 4.348 4.256 7.17l1.2 6.471a5.009 5.009 0 01-1.091 4.141h0a4.867 4.867 0 01-3.753 1.724l-11.019-.048-8.626 5.284-24.7-.424-17.8.226-23.455-3.532-5.132-.4a3.63 3.63 0 01-2.916-1.885 9.913 9.913 0 01-1.256-4.227A19.573 19.573 0 014.105 37.2c1.614-3.161 4-3.534 7.083-14.039s4.456-15.3 7.573-18.833S27.645.567 27.645.567z"
                  data-name="Path 76565"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M76.422 31.475s-.025 1.815-.434 5.453a34.487 34.487 0 00-.843 4.663c0 .863.161.823.249 2.028a29.319 29.319 0 01-.468 7.57c.007 1.54.249 3.376-1.274 3.369l-33.1-.154a3.654 3.654 0 01-2.724-1.248h0a3.73 3.73 0 01-.932-2.45s-.16-1.803-.183-6.652.221-11.755.221-11.755"
                  data-name="Path 76566"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M90.415 34.518a10.357 10.357 0 01-3.652.448c-1.715-.18-6.392-.147-6.952-.249s-4.358-1.122-4.358-1.122l-64.393.553"
                  data-name="Path 76567"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M38.586 35.862l4.009.019a.748.748 0 00.748-.757h0a.765.765 0 00-.755-.764l-4.009-.019a.748.748 0 00-.749.757h0a.765.765 0 00.756.764z"
                  data-name="Path 76568"
                ></path>
                <path
                  fill="#ecf0f1"
                  d="M20.676 2.424l2.824-.346c1.134.006 2.108 1.869 3.14 2.335 1.681.731 2.5.982 3.525 3.8l9.918 18.111a1.4 1.4 0 01-.163 1.271 1.358 1.358 0 01-1.123.587l-35.65-.166a2.389 2.389 0 01-1.691-.716 2.444 2.444 0 01-.7-1.708L0 15.442.652 3.093A3.093 3.093 0 011.539.9 3.024 3.024 0 013.707 0z"
                  data-name="Path 76569"
                  transform="translate(36.67 2.528)"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M56.51 4.567l3.481.082c2.153.011 2.186 1.345 3.356 2.371.623.52 2.449.628 3.119 2.475l10.283 19.357a1.4 1.4 0 01-.163 1.276 1.358 1.358 0 01-1.123.587l-35.647-.171a2.39 2.39 0 01-1.69-.716 2.444 2.444 0 01-.7-1.708l-.81-10.586.705-11.913a3.093 3.093 0 01.888-2.193 3.024 3.024 0 012.167-.9l9.689.446z"
                  data-name="Path 76570"
                ></path>
                <path
                  fill="#eceff1"
                  d="M21.07 1.888l.106 23.683a1.994 1.994 0 01-2 2.018L0 27.5 5.554 8.129a11.161 11.161 0 013.189-5.165A11 11 0 0115.928.073L19.162 0A1.864 1.864 0 0120.5.542a1.907 1.907 0 01.57 1.346z"
                  data-name="Path 76571"
                  transform="translate(12.736 3.043)"
                ></path>
                <g fill="#fff" clipPath="url(#clip-path-3)" data-name="Group 57761" transform="translate(12.736 3.043)">
                  <path
                    d="M2.311 0l15.043 18.409a1.974 1.974 0 01-1.235.435l-7-.033L0 8.064z"
                    data-name="Path 76572"
                    transform="translate(3.062 8.744)"
                  ></path>
                  <path
                    d="M0 4.1L1.174 0 6.9 7.2l-4.2-.02z"
                    data-name="Path 76573"
                    transform="translate(.878 20.337)"
                  ></path>
                </g>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M33.806 4.931l-.333 12.439.439 11.246a1.994 1.994 0 01-2 2.018l-19.176-.091 5.554-19.371a11.161 11.161 0 013.189-5.165h0a11 11 0 017.185-2.891l3.138.646c.5-.009 1.08-.532 1.439-.177a1.907 1.907 0 01.565 1.346z"
                  data-name="Path 76575"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M101.107 44.23a11.53 11.53 0 012.686 2.141 10.841 10.841 0 01.213 1.735c.005 1.141-1.923 2.756-2.675 3.007s-.906-.86-.906-.86.639-4.563.682-6.023z"
                  data-name="Path 76576"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M99.558 34.686l-.456.086a1.4 1.4 0 00-1.108 1.647l1.235 6.446A1.414 1.414 0 00100.867 44l.456-.086a1.4 1.4 0 001.106-1.647l-1.917-3.032.684-3.414a1.414 1.414 0 00-1.638-1.135z"
                  data-name="Path 76577"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M2.184 39.622a2.262 2.262 0 012.2 2.287l.018 4.069a2.212 2.212 0 01-2.179 2.266 2.262 2.262 0 01-2.2-2.287L0 41.888a2.212 2.212 0 012.184-2.266z"
                  data-name="Path 76578"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeWidth="1"
                  d="M89.852 65.099c6.474.03 8.94-4.314 8.91-10.862S94.918 42.08 88.444 42.05a11.66 11.66 0 00-11.67 11.8c.03 6.548 6.6 11.218 13.078 11.249z"
                  data-name="Path 76579"
                ></path>
                <g clipPath="url(#clip-path-4)" data-name="Mask Group 647" transform="translate(76.774 42.05)">
                  <path
                    fill="#fff"
                    d="M8.718 0l-.433 15.021 7.4-12.326zM0 26.757l8.281-11.751-1.524 14.939z"
                    data-name="Path 76580"
                    transform="translate(3.438 -3.166)"
                  ></path>
                </g>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M90.374 65.127c6.929-.2 8.212-4.271 8.183-10.819S94.918 42.08 88.444 42.05a11.7 11.7 0 00-10.27 6.145 11.524 11.524 0 00-1.4 5.655c.03 6.548 6.67 11.481 13.6 11.277z"
                  data-name="Path 76582"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M88.462 46.109a7.84 7.84 0 017.745 7.833 7.669 7.669 0 01-7.675 7.761 7.84 7.84 0 01-7.745-7.833 7.669 7.669 0 017.675-7.761z"
                  data-name="Path 76583"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M88.472 48.265a5.672 5.672 0 015.6 5.666 5.548 5.548 0 01-5.552 5.615 5.672 5.672 0 01-5.6-5.667 5.548 5.548 0 015.552-5.614z"
                  data-name="Path 76584"
                ></path>
                <path
                  fill="#263238"
                  d="M11.9 23.415a11.727 11.727 0 0011.84-11.681A11.853 11.853 0 0011.845 0 11.727 11.727 0 000 11.681a11.853 11.853 0 0011.9 11.734z"
                  data-name="Path 76585"
                  transform="rotate(-118.49 29.551 29.555)"
                ></path>
                <g clipPath="url(#clip-path-5)" data-name="Group 57762" transform="translate(6.351 37.597)">
                  <path
                    fill="#fff"
                    d="M0 5.878l14.028 5.1L4.577 0zm22.64 16.748l-8.619-11.644 13.627 6.126z"
                    data-name="Path 76586"
                    transform="translate(1.926 5.018)"
                  ></path>
                </g>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M32.573 48a11.728 11.728 0 00-15.915-4.836 11.854 11.854 0 00-4.64 16.053 11.728 11.728 0 0015.918 4.84A11.854 11.854 0 0032.573 48z"
                  data-name="Path 76588"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M29.287 50.34a7.729 7.729 0 00-10.258-3.835 7.779 7.779 0 00-3.7 10.34 7.729 7.729 0 0010.257 3.835 7.779 7.779 0 003.701-10.34z"
                  data-name="Path 76589"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M23.812 48.176a5.516 5.516 0 00-6.882 3.83 5.7 5.7 0 003.852 6.996 5.516 5.516 0 006.882-3.831 5.7 5.7 0 00-3.852-6.995z"
                  data-name="Path 76590"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M74.979 28.33c-.9 2.023-1.111 3.908-.44 4.212s1.917-1.094 2.815-3.117 1.11-3.912.439-4.216-1.913 1.094-2.814 3.121z"
                  data-name="Path 76591"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M52.018 9.738a6.472 6.472 0 00-3.194 1.413c-1.134 1.13-1.063 2.332-1.355 3.112s-3.368.474-3.7.896-2.276 3.67-2.276 3.67l-7.309 4.977"
                  data-name="Path 76592"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M59.772 22.617a10.377 10.377 0 01-2.738-2.46 8.428 8.428 0 01-1.228-3.191c-.265-.78-2.864-1.732-3.155-2.221s-2.013-4.019-2.013-4.019"
                  data-name="Path 76593"
                ></path>
              </g>
            </g>
            <g data-name="Group 57766" transform="scale(-1) rotate(-2 -2317.353 5927.875)">
              <g data-name="freepik--Car--inject-242">
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M27.763 69.095l13.605.61 14.887-.869 5.39-1.509c1.578 0 5.491 1.134 5.549-.063.768-.679 1.4-4.223 1.783-5.178l9.3-17.608a4.439 4.439 0 013.2-2.7 11.7 11.7 0 015.681.717s3.876-.608 4.2-.689c1.363-.323 3.319-3.289 4.679-4.385.456-2.017 3.717-4.337 4.231-7.16l1.177-6.47a5.039 5.039 0 00-1.1-4.146h0a4.9 4.9 0 00-3.754-1.74l-11.01.015-8.643-5.315-24.678.342-17.794-.285-23.437 3.456-5.128.387a3.6 3.6 0 00-2.908 1.877 9.874 9.874 0 00-1.242 4.223 19.684 19.684 0 002.367 9.759c1.62 3.168 4.006 3.549 7.12 14.07s4.5 15.321 7.629 18.868 8.896 3.793 8.896 3.793z"
                  data-name="Path 76594"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M76.416 38.333s-.031-1.773-.451-5.327a33.1 33.1 0 01-.858-4.556c0-.842.158-.8.242-1.98a28.034 28.034 0 00-.492-7.393c.002-1.503.357-4.26-1.169-4.26l-33.075.043a3.664 3.664 0 00-2.719 1.21h0a3.572 3.572 0 00-.924 2.39s-.276 2.726-.282 7.457.257 11.484.257 11.484"
                  data-name="Path 76595"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M90.392 35.335a10.37 10.37 0 00-3.652-.461 8.372 8.372 0 00-3.2 1.16c-.761.31-3.188-1.034-3.747-.933s-4.352 1.108-4.352 1.108l-64.362-.765"
                  data-name="Path 76596"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M38.585 33.818l4.007-.005a.754.754 0 01.751.76h0a.759.759 0 01-.753.762l-4.007.005a.754.754 0 01-.751-.76h0a.759.759 0 01.753-.762z"
                  data-name="Path 76597"
                ></path>
                <path
                  fill="#ecf0f1"
                  d="M20.707 25.711l2.82.356c4.091-.007 5.242-2.221 6.641-6.116l9.856-18.088a1.406 1.406 0 00-.167-1.272A1.367 1.367 0 0038.733 0L3.1.048a2.371 2.371 0 00-1.682.709 2.43 2.43 0 00-.7 1.707L0 12.618l.691 12.358a3.117 3.117 0 00.894 2.2 3.04 3.04 0 002.169.908z"
                  data-name="Path 76598"
                  transform="translate(36.727 39.096)"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M56.6 65.19l3.479-.071c4.091-.007 5.057-.932 6.456-4.827l10.216-19.333a1.406 1.406 0 00-.167-1.272 1.367 1.367 0 00-1.124-.591l-35.631.048a2.371 2.371 0 00-1.684.709 2.43 2.43 0 00-.7 1.707l-.77 10.591.743 11.921a3.117 3.117 0 00.894 2.2 3.04 3.04 0 002.169.908l9.682-.414z"
                  data-name="Path 76599"
                ></path>
                <path
                  fill="#eceff1"
                  d="M21.141 25.721l.031-23.7a2.01 2.01 0 00-2-2.025L0 .026l5.613 19.4a11.264 11.264 0 003.2 5.178 11.055 11.055 0 007.191 2.917l3.233.083a1.85 1.85 0 001.341-.537 1.9 1.9 0 00.563-1.346z"
                  data-name="Path 76600"
                  transform="translate(12.766 39.029)"
                ></path>
                <g
                  fill="#fff"
                  clipPath="url(#clip-path-6)"
                  data-name="Group 57764"
                  transform="translate(12.766 39.029)"
                >
                  <path
                    d="M2.335 18.809L17.312.44A1.983 1.983 0 0016.076 0L9.084.009 0 10.733z"
                    data-name="Path 76601"
                    transform="translate(3.095)"
                  ></path>
                  <path
                    d="M0 3.08l1.186 4.1L6.883 0l-4.2.006z"
                    data-name="Path 76602"
                    transform="translate(.887 .015)"
                  ></path>
                </g>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M33.907 64.75l-.373-12.446.4-11.249a2.01 2.01 0 00-2-2.025l-19.168.025 5.613 19.4a11.264 11.264 0 003.2 5.178h0a11.055 11.055 0 007.191 2.917l3.134-.636c.5.011 1.081.536 1.439.182a1.9 1.9 0 00.564-1.346z"
                  data-name="Path 76604"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M101.047 25.654a11.418 11.418 0 002.679-2.133 10.831 10.831 0 00.207-1.736c.002-1.141-1.931-2.763-2.686-3.017s-.9.862-.9.862.654 4.563.7 6.024z"
                  data-name="Path 76605"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M99.184 34.19c-.869.776-1.366.036-1.222-.731l1.212-6.445a1.4 1.4 0 011.638-1.128l.452.085a1.41 1.41 0 011.11 1.655l-.85 3.419-.36 3.022c-.145.768-1.222.266-1.98.123z"
                  data-name="Path 76606"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M2.2 21.309a2.23 2.23 0 012.19 2.275l-.003 4.071a2.244 2.244 0 01-2.2 2.281A2.23 2.23 0 010 27.661l.005-4.071A2.244 2.244 0 012.2 21.309z"
                  data-name="Path 76607"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeWidth="1"
                  d="M89.659 4.906c6.471-.009 9.023 4.177 9.014 10.727s-3.8 12.15-10.275 12.159a11.752 11.752 0 01-11.701-11.845c.008-6.551 6.491-11.032 12.962-11.041z"
                  data-name="Path 76608"
                ></path>
                <g clipPath="url(#clip-path-7)" data-name="Mask Group 648" transform="translate(76.697 4.401)">
                  <path
                    fill="#fff"
                    d="M6.8 25.947l-.481-15.03 7.438 12.357zM0 2.011l6.314 8.921L4.977 0z"
                    data-name="Path 76609"
                    transform="translate(5.398 .613)"
                  ></path>
                </g>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M90.253 4.709c6.471-.009 8.221 4.3 8.213 10.851s-3.597 12.223-10.069 12.232a11.78 11.78 0 01-10.287-6.183 11.592 11.592 0 01-1.413-5.663c.008-6.55 7.085-11.228 13.556-11.237z"
                  data-name="Path 76611"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M88.424 8.13a7.729 7.729 0 017.7 7.79 7.778 7.778 0 01-7.716 7.81 7.729 7.729 0 01-7.7-7.789 7.778 7.778 0 017.716-7.811z"
                  data-name="Path 76612"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M88.421 10.288a5.591 5.591 0 015.567 5.636 5.627 5.627 0 01-5.582 5.651 5.591 5.591 0 01-5.567-5.636 5.627 5.627 0 015.582-5.651z"
                  data-name="Path 76613"
                ></path>
                <path
                  fill="#263238"
                  d="M11.893 0a11.664 11.664 0 0111.79 11.684 11.916 11.916 0 01-11.894 11.789A11.664 11.664 0 010 11.789 11.916 11.916 0 0111.893 0z"
                  data-name="Path 76614"
                  transform="rotate(118.49 15.776 16.965)"
                ></path>
                <g clipPath="url(#clip-path-8)" data-name="Group 57765" transform="translate(6.29)">
                  <path
                    fill="#fff"
                    d="M0 16.682l14-5.061-9.407 10.957zM22.575 0L14 11.621l13.6-6.083z"
                    data-name="Path 76615"
                    transform="translate(1.961 4.398)"
                  ></path>
                </g>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M32.541 21.644a11.665 11.665 0 01-15.894 4.79 11.917 11.917 0 01-4.69-16.078 11.665 11.665 0 0115.894-4.79 11.917 11.917 0 014.69 16.078z"
                  data-name="Path 76617"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M29.242 19.3a7.682 7.682 0 01-10.24 3.801 7.826 7.826 0 01-3.729-10.356 7.682 7.682 0 0110.24-3.801A7.826 7.826 0 0129.242 19.3z"
                  data-name="Path 76618"
                ></path>
                <path
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M23.785 21.45a5.55 5.55 0 01-6.89-3.856 5.668 5.668 0 013.827-6.986 5.55 5.55 0 016.89 3.856 5.668 5.668 0 01-3.827 6.986z"
                  data-name="Path 76619"
                ></path>
                <path
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1"
                  d="M74.984 41.474c-.903-2.027-1.123-3.914-.453-4.215s1.919 1.1 2.823 3.128 1.123 3.918.453 4.219-1.916-1.101-2.823-3.132z"
                  data-name="Path 76620"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M60.637 60.253a10.93 10.93 0 00-2.645-2.652 8.303 8.303 0 00-3.224-1.075c-.787-.228-1.94-2.82-2.443-3.093S48.213 51.6 48.213 51.6l-7.517-6.026"
                  data-name="Path 76621"
                ></path>
                <path
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeWidth="1"
                  d="M63.636 51.047a10.376 10.376 0 00-3.63-.598 8.347 8.347 0 00-3.237 1.043c-.774.281-3.15-1.15-3.713-1.069s-4.384.949-4.384.949"
                  data-name="Path 76622"
                ></path>
              </g>
            </g>
          </g>
        </g>
        <path fill="#263238" d="M140 .5H0v-1h140z" data-name="Line 254" transform="translate(13561 -2435.058)"></path>
      </g>
    </svg>
  )
}

export default TplCategoryIcon
